<!--  -->
<template>
  <div style="width: 100%; height: 100%">
    <div style="margin-bottom: 10px; width: 100%">
      <el-date-picker
        v-model="value1"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="mini"
         @change="changeList"
      >
      </el-date-picker>
    </div>
    <div id="myChartAll" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import {PostDateSales} from "@/api/index.js"
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    list: Object,
  },
  data() {
    //这里存放数据
    return {
      list2: [],
      value1: [],
         myChart: "",
      option: {},
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
         //获取上一个月日期
    getLastMonth(date) {
        var arr = date.split('-');
    var year = arr[0]; //获取当前日期的年份
    var month = arr[1]; //获取当前日期的月份
    var day = arr[2]; //获取当前日期的日
    var days = new Date(year, month, 0);
    days = days.getDate(); //获取当前日期中月的天数
    var year2 = year;
    var month2 = parseInt(month) - 1;
    if (month2 == 0) {
        year2 = parseInt(year2) - 1;
        month2 = 12;
    }
    var day2 = day;
    var days2 = new Date(year2, month2, 0);
    days2 = days2.getDate();
    if (day2 > days2) {
        day2 = days2;
    }
    if (month2 < 10) {
        month2 = '0' + month2;
    }
    var t2 = year2 + '-' + month2 + '-' + day2;
    return t2;
    },
       //获取当前年月日
    getDate(){
       var date = new Date();
       var year=date.getFullYear(); //获取完整的年份(4位)
       var month=date.getMonth()+1; //获取当前月份(0-11,0代表1月)
       var day=date.getDate(); //获取当前日(1-31); //获取当前月份(0-11,0代表1月)
       var time=year+'-'+month+'-'+day;  //YYYY-MM-dd
       return time;//返回当前日期YYYY-MM-dd
    },
          //连接日期获取商品总量数据网络请求
        changeList() {
          console.log(this.value1)
       this.PostDateSales({
        start_date:this.value1[0],
        end_date:this.value1[1],
       })
    },
    async getList() {
      // let info = await this.$axios.post("cheshia");
      // console.log(info);
      // this.list2 = info.data.data;
      this.drawLine();
    },
    drawLine() {
      var chartDom = document.getElementById("myChartAll");
      this.myChart = this.$echarts.init(chartDom);
        var option;
        const colors = ['#a6c30f','#5470C6','#1E90FF' ];
option = {
  color: colors,
  title: {
    text: '销售汇总统计表'
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    }
  },
  // grid: {
  //   right: '20%'
  // },
  legend: {
    data: ['销售额/元', '销售量/份', '客单价/元']
  },
  xAxis: [
    {
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      // axisLabel: {  
			// 		interval:0,
      //     rotate:-30  //倾斜的程度
      // },
      // prettier-ignore
      data: ['07-05（周三）','07-06（周四）','07-07（周五）','07-08（周六）','07-09（周日）','07-10（周一）','07-11（周二）','07-12（周三）']
    }
  ],
  yAxis: [
    {
       type: 'value',
      name: '销售量/份',
      position: 'right',
      alignTicks: true,
      axisLine: {
        show: true,
        lineStyle: {
          color: colors[0]
        }
      },
    },
    {
      type: 'value',
      name: '客单价/元',
      position: 'right',
      offset: 40,
      nameLocation:'end',
      nameTextStyle:{
        align:'left'
      },
      alignTicks: true,
      axisLine: {
        show: true,
        lineStyle: {
          color: colors[1]
        }
      }
    },
  {
      type: 'value',
      name: '销售额/元',
      position: 'left',
      alignTicks: true,
      axisLine: {
        show: true,
        lineStyle: {
          color: colors[2]
        }
      }
    },
  ],
  series: [
    {
      name: '销售量/份',
      type: 'line',
      yAxisIndex: 0,
      data: [
        2.00,3.00,4.00,1.00,2.00,1.00,3.00,6.00,3.00,4.00,4.00,2.00,2.00,3.00,
        2.00,3.00,4.00,1.00,2.00,1.00,3.00,6.00,3.00,4.00,4.00,2.00,2.00,3.00,
        2.00,3.00,4.00,1.00,2.00,1.00,3.00,6.00,3.00,4.00,4.00,2.00,2.00,3.00,
        2.00,3.00,4.00,1.00,2.00,1.00,3.00,6.00,3.00,4.00,4.00,2.00
      ]
    },
    {
      name: '客单价/元',
      stack: 'Search Engine',
      type: 'line',
      yAxisIndex: 1,
      data: [
        138.00, 66.00, 100.00, 128.00, 46.00, 200.00, 300.00, 100.00, 38.00, 46.00, 238.00, 99.00,18.00,
        338.00, 66.00, 100.00, 128.00, 46.00, 200.00, 300.00, 100.00, 38.00, 46.00, 238.00, 99.00,18.00,
        338.00, 66.00, 100.00, 128.00, 46.00, 200.00, 300.00, 100.00, 38.00, 46.00, 238.00, 99.00,18.00,
        338.00, 66.00, 100.00, 128.00, 46.00, 200.00, 300.00, 100.00, 38.00, 46.00, 238.00
      ]
    },
    {
      name: '销售额/元',
      type: 'bar',
      yAxisIndex: 2,
      smooth: true,
      stack: 'Search Engine',
      label: {
        show: true,
        position: 'top',
        formatter:num=>{
          if(num.value>0){
            return num.value
          }else{
            return ''
          }
        }
      },
      data: [
        400.00,200.00,300.00,100.00,180.00,100.00,558.00, 200.00,300.00,100.00,400.00,180.00,100.00,58.00,
        500.00,200.00,300.00,100.00,180.00,100.00,558.00, 200.00,300.00,100.00,400.00,180.00,100.00,58.00,
        500.00,200.00,300.00,100.00,180.00,100.00,558.00, 200.00,300.00,100.00,400.00,180.00,100.00,58.00,
        500.00,200.00,300.00,100.00,180.00,100.00,558.00, 200.00,300.00,100.00,400.00,180.00,
      ]
    },

  ]
};
      this.option = option;
      this.myChart.setOption(this.option);
    },
      //-------------------------------网络请求函数---------------------------------------
        //分类商品网络请求函数
    async PostDateSales(data){
      let res=await PostDateSales(data);
      if(res.data.code==1){
        var numArr=[];//订单数数组
        var dateArr=[];//X轴日期数组
        var orderNumArr=[];//销售额数组
        var maxMoneyArr=[];//客单价数组
        res.data.data.result.forEach(item => {
          numArr.push(item.num);
          orderNumArr.push(item.payment_amount);
          maxMoneyArr.push(item.max_payment_amount);
          dateArr.push(item.date.split("-").splice(1,2).join("-")+`\n${item.week_cn}`);
          //console.log(item.date.split("-").splice(1,2).join("-")+`(${item.week_cn})`)
        });
      //  console.log(dateArr)
          //配置echars
        this.option.series[0].data=numArr;
        this.option.series[1].data=maxMoneyArr;
        this.option.series[2].data=orderNumArr;
        this.option.xAxis[0].data=dateArr;
        this.myChart.setOption(this.option);
         this.$message({
          message: res.data.message,
          type: 'success'
        });
      }else{
        this.$message.error(res.data.message);
      }
      console.log(res)
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
       var endDate=this.getDate();
    var stratDate=this.getLastMonth(endDate);
    this.value1.push(stratDate);
    this.value1.push(endDate);
    this.PostDateSales({
      end_date:this.value1[1],
      start_date:this.value1[0]
    });
  },
  beforeMount() {}, //生命周期 - 挂载之前
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
/* #myChart {
  height: 100%;
  width: 100%;
} */
.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 100%;
}
</style>